import { render, staticRenderFns } from "./MaterialDamageResolution.vue?vue&type=template&id=39f3accd"
import script from "./MaterialDamageResolution.vue?vue&type=script&lang=js"
export * from "./MaterialDamageResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports